<template>
  <div class="toast-manager">
    <ToastNotification
      v-for="toast in toasts"
      :key="toast.id"
      :show="toast.show"
      :type="toast.type"
      :title="toast.title"
      :message="toast.message"
      :show-actions="toast.showActions"
      :auto-close="toast.autoClose"
      :duration="toast.duration"
      @close="removeToast(toast.id)"
      @view-cart="handleViewCart(toast.id)"
      @continue-shopping="handleContinueShopping(toast.id)"
    />
  </div>
</template>

<script>
import ToastNotification from './ToastNotification.vue'

export default {
  name: 'ToastManager',
  components: {
    ToastNotification
  },
  data() {
    return {
      toasts: [],
      nextId: 1
    }
  },
  methods: {
    addToast(options) {
      const toast = {
        id: this.nextId++,
        show: true,
        type: options.type || 'success',
        title: options.title || '',
        message: options.message || '',
        showActions: options.showActions || false,
        autoClose: options.autoClose !== false,
        duration: options.duration || 4000,
        ...options
      }
      
      this.toasts.push(toast)
      
      // Limit to 5 toasts maximum
      if (this.toasts.length > 5) {
        this.toasts.shift()
      }
      
      return toast.id
    },
    
    removeToast(id) {
      const index = this.toasts.findIndex(toast => toast.id === id)
      if (index > -1) {
        this.toasts.splice(index, 1)
      }
    },
    
    clearAllToasts() {
      this.toasts = []
    },
    
    handleViewCart(toastId) {
      this.$emit('view-cart')
      // Defer clearing toasts to next tick to avoid Vue destroy errors
      // This prevents "Cannot read properties of undefined (reading '_wrapper')"
      // which happens when destroying a component while its click handler is still executing
      this.$nextTick(() => {
        this.clearAllToasts()
      })
    },

    handleContinueShopping(toastId) {
      this.$emit('continue-shopping')
      // Defer removal to next tick for same reason as above
      this.$nextTick(() => {
        this.removeToast(toastId)
      })
    }
  }
}
</script>

<style scoped>
.toast-manager {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1000;
  pointer-events: none;
  padding: 1rem;
}

.toast-manager > * {
  pointer-events: auto;
  margin-bottom: 0.5rem;
}

/* Mobile adjustments */
@media (max-width: 640px) {
  .toast-manager {
    left: 1rem;
    right: 1rem;
  }
}
</style>
